/** @format */
import { LinkProps as FeatherLinkProps } from '@mpb-com/feather/components/atoms/link';

export {
    LinkColor,
    LinkElementType,
    LinkSize,
    LinkTarget,
    LinkVariant,
} from '@mpb-com/feather/components/atoms/link';

export type { StyledLinkProps } from '@mpb-com/feather/components/atoms/link';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LinkProps = FeatherLinkProps & {
    'data-testid'?: string;
    'aria-label'?: string;
};
